/**
 * 解析后端下发的 properties 风格文案：
 * "agency_title" = "Agency";
 * agencycommon_* 会映射为 common.*
 */
export function parseRemoteLocales(raw: string) {
  const result: Record<string, any> = {}
  if (!raw) return result

  const len = raw.length
  let i = 0

  const isWs = (c: string) => c === ' ' || c === '\t' || c === '\n' || c === '\r'

  const readQuoted = (): string | null => {
    if (raw[i] !== '"') return null
    i++
    let out = ''
    while (i < len) {
      const c = raw[i]
      if (c === '\\') {
        const next = raw[i + 1]
        if (next === undefined) break
        switch (next) {
          case 'n':
            out += '\n'
            i += 2
            continue
          case 'r':
            out += '\r'
            i += 2
            continue
          case 't':
            out += '\t'
            i += 2
            continue
          case '"':
            out += '"'
            i += 2
            continue
          case '\\':
            out += '\\'
            i += 2
            continue
          default:
            out += next
            i += 2
            continue
        }
      }
      if (c === '"') {
        i++
        return out
      }
      out += c
      i++
    }
    return null
  }

  const setByPath = (path: string, value: string) => {
    const segments = path.split('.').filter(Boolean)
    if (!segments.length) return
    let cursor = result
    segments.forEach((segment, idx) => {
      if (idx === segments.length - 1) {
        cursor[segment] = value
        return
      }
      if (!cursor[segment] || typeof cursor[segment] !== 'object') {
        cursor[segment] = {}
      }
      cursor = cursor[segment]
    })
  }

  while (i < len) {
    while (i < len && isWs(raw[i])) i++
    if (i >= len) break

    if (raw[i] !== '"') {
      while (i < len && raw[i] !== '\n') i++
      continue
    }

    const rawKey = readQuoted()
    if (rawKey == null) break

    while (i < len && isWs(raw[i])) i++
    if (raw[i] !== '=') {
      while (i < len && raw[i] !== '\n') i++
      continue
    }
    i++
    while (i < len && isWs(raw[i])) i++

    if (raw[i] !== '"') {
      while (i < len && raw[i] !== '\n') i++
      continue
    }

    const rawValue = readQuoted()
    if (rawValue == null) break

    while (i < len && isWs(raw[i])) i++
    if (raw[i] === ';') i++

    const keySegments = rawKey.split('_').filter(Boolean)
    if (keySegments[0] === 'agencycommon') {
      keySegments[0] = 'common'
    }
    const key = keySegments.join('.')
    setByPath(key, rawValue)
  }

  return result
}
